<ion-content class="edit-user">

  <app-header [title]="'Dept Assignment'"></app-header>

  <!-- Loader -->
  <div class="page-loader" *ngIf="!loaded">
    <ion-spinner></ion-spinner>
  </div>

  <form  #form="ngForm">

    <ion-grid style="margin-top:70px">

      <ion-row>
        <ion-col size="12">
          <ion-text>
            <strong>User Customer Selection for: <h4 style="color:blue">{{ customerName }}</h4></strong>
          </ion-text>
        </ion-col>
      </ion-row>
    <ion-text style="padding-left:5px">
        <strong>Current Customer Assignment</strong>
      </ion-text>
      <ion-card>
        <ion-card-content>

          <ion-row class="ion-align-items-center">
            <ion-col size="12" size-md="8">
              <strong>Customer Code</strong>
              <div>
                <ion-input
                  type="text"
                  placeholder="Enter first name"
                  class="ion-text-left color-light"
                  [(ngModel)]="newCustomer"
                 (keydown.enter)="onEnterKey($event)"
                ></ion-input>
              </div>
            </ion-col>

            <ion-col size="12" size-md="4" style="margin-top:15px">
              <ion-button (click)="addCustomer()" class="gallaghergreen">
                  Add Customer
              </ion-button>
            </ion-col>
          </ion-row>

        </ion-card-content>
      </ion-card>
      <ng-container *ngFor="let cust of assignedDepts">

        <ion-card>

          <ion-item lines="full">
            <ion-label>
              <strong>({{ cust.customerCode }})</strong>
              {{ cust.customerName }}
            </ion-label>
            <ion-button style="padding-right:10%"
              fill="clear"
              color="danger"
              slot="end"
              (click)="removeCustomer(cust.customerCode)">
              Remove
            </ion-button>
          </ion-item>

          <ng-container *ngIf="cust.departments?.length>0; else allSelected">

            <ion-item
              *ngFor="let dept of cust.departments"
              lines="none">

              <ion-label style="padding-left:10%">
                <small>({{ dept.departmentCode }})</small>
                {{ dept.departmentName }}
              </ion-label>

              <ion-button
                fill="clear"
                color="danger"
                slot="end"
                (click)="removeDepartment(cust.customerCode, dept.departmentCode)">
                Remove
              </ion-button>
            </ion-item>
          </ng-container>

          <!-- All Selected -->
          <ng-template #allSelected style="padding-left:10%">
            <ion-item lines="none">
              <ion-label>
                All Departments are Currently Selected' 
              </ion-label>
            </ion-item>
          </ng-template>

          <ion-item style="padding-left:9%">
            <ng-select
              style="width:400px"
              [items]="cust.departmentList"
              bindLabel="departmentName"
              bindValue="departmentCode"
              [(ngModel)]="cust.selectedDept"
              placeholder="Select Department"
              [searchable]="true"
              [appendTo]="'body'"
              dropdownPosition="top">

              <ng-template ng-option-tmp let-item="item">
              ({{ item.departmentCode }}) {{ item.departmentName }}
            </ng-template>

            <ng-template ng-label-tmp let-item="item">
              ({{ item.departmentCode }}) {{ item.departmentName }}
            </ng-template>

            </ng-select>
          <ion-button
              slot="end"
              fill="outline"
              class="add-btn"
              (click)="addDepartment(cust.customerCode,cust.selectedDept)">
              {{ isCC ? 'Add CC' : 'Add Dept' }}
            </ion-button> 
          </ion-item>
        </ion-card>
      </ng-container>
    </ion-grid>

  </form>

</ion-content>
